// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ZV9P","fullHeight":"styles_fullHeight__2fk8b"};